import React from 'react'
import { GridComponent, ColumnsDirective, ColumnDirective, Page, Selection, Inject,Search, Edit, Toolbar, Sort, Filter } from '@syncfusion/ej2-react-grids/src'

import { Header } from '../components'
import Swal from 'sweetalert2'

const Feedbacks = () => {
const [feedbackData, setFeedbackData] = React.useState([]);

React.useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL + '/api/forms', {
        headers: {
          'api-key': process.env.REACT_APP_API_KEY
        }
      });
      const data = await response.json();
      setFeedbackData([...data].reverse());
    } catch (error) {
      console.error('Error fetching feedback data:', error);
    }
  };

  fetchData();
}, []);

  const exportToCSV = () => {
    const csvRows = [];
    const headers = Object.keys(feedbackData[0] || {}).join(',');
    csvRows.push(headers);

    feedbackData.forEach(item => {
      const values = Object.values(item).map(value =>
        typeof value === 'string' ? `"${value.replace(/"/g, '""')}"` : value
      );
      csvRows.push(values.join(','));
    });

    const csvString = csvRows.join('\n');
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'Vaaar_feedbacks.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  };

  const feedbackGridImage = (props) => (
    <div className="image flex gap-4">
    
      <div>
        <p>{props.name}</p>
        <p>{props.email}</p>
      </div>
    </div>
  );

   const feedbacksGrid = [
    { type: 'checkbox', width: '50' },
    { headerText: 'Name',
      width: '150',
      template: feedbackGridImage,
      textAlign: 'Center' },
    { field: 'phone',
      headerText: 'Phone No.',
      width: '150',
      textAlign: 'Center' },
   
    {
      field: 'subject',
      headerText: 'Subjects',
      width: '100',
      textAlign: 'Center' },
  
    { field: 'message',
      headerText: 'Message',
      width: '150',
      textAlign: 'Center' },
  
    { field: 'createdAt',
      headerText: 'Created At',
      width: '120',
      textAlign: 'Center',
   
    },
    { field: 'updatedAt',
      headerText: 'Updated At',
      width: '120',
      textAlign: 'Center',
   
    },
  
  ];

  return (
    <div className="m-2 md:m-10 sm:mt-24 p-2 md:p-4 bg-white rounded-3xl">
      <Header category="Page" title="Feedbacks" />
      <GridComponent
        dataSource={feedbackData}
        allowPaging
        allowSorting
        toolbar={['Delete', {text: 'Export', tooltipText: 'Export', prefixIcon: 'e-icons e-export', id: 'export'}, 'Search']}
        toolbarClick={(args) => {
          if (args.item.id === 'export') {
            exportToCSV();
          }
        }}
        editSettings={{
          allowDeleting: true,
          allowEditing: true
        }}
        width="auto"
        actionBegin={async (args) => {
          if (args.requestType === 'delete') {
            args.cancel = true;

            const result = await Swal.fire({
              title: 'Are you sure?',
              text: "You won't be able to revert this!",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, delete it!'
            });

            if (result.isConfirmed) {
              try {
                const selectedRecords = args.data;
                const deletePromises = selectedRecords.map(record =>
                  fetch(`${process.env.REACT_APP_API_BASE_URL}/api/forms/${record._id}`, {
                    method: 'DELETE',
                    headers: {
                      'api-key': process.env.REACT_APP_API_KEY
                    }
                  })
                );

                const responses = await Promise.all(deletePromises);
                const allSuccessful = responses.every(response => response.ok);

                if (allSuccessful) {
                  const deletedIds = selectedRecords.map(record => record._id);
                  setFeedbackData(feedbackData.filter(item => !deletedIds.includes(item._id)));
                  Swal.fire({
                    title: 'Deleted!',
                    text: 'Your feedback has been deleted.',
                    icon: 'success',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK'
                  });
                } else {
                  Swal.fire(
                    'Error!',
                    'There was an error deleting the feedback.',
                    'error'
                  );
                }
              } catch (error) {
                console.error('Error deleting feedback:', error);
                Swal.fire(
                  'Error!',
                  'There was an error deleting the feedback.',
                  'error'
                );
              }
            }
          }
        }}
      >
        <ColumnsDirective>
          {feedbacksGrid.map((item, index) => (
            <ColumnDirective key={index} {...item} />
          ))}
        </ColumnsDirective>
        <Inject services={[Page,Search , Toolbar, Selection, Edit, Sort, Filter]} />
      </GridComponent>
    </div>
  )
}

export default Feedbacks;
